export default {
    UNPUBLISHED: 'Unpublished',
    PENDING: 'Pending',
    ON_HOLD: 'On Hold',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
    POSTED: 'Posted',
    CLOSED: 'Closed',
};
